// extracted by mini-css-extract-plugin
export default {"reviews_parent":"Review_reviews_parent__Cy0Pi","reviews_child":"Review_reviews_child__TPMBy"};